import { Component, Input } from '@angular/core';
import { ModalService } from '../../../services/modal.service';

@Component({
  selector: 'app-ok-modal',
  templateUrl: './ok-modal.component.html',
  styleUrl: './ok-modal.component.scss',
})
export class OkModalComponent {
  @Input() header: string;
  @Input() message: string;
  @Input() okLabel = $localize`Ok`;

  constructor(private modalService: ModalService) {}

  onOk() {
    this.modalService.close();
  }

  onCancel() {
    this.modalService.dismiss();
  }
}
